import { FC } from "react";

interface ContactsPeopleIconSVGProps {
    className?: string;
}

const ContactsPeopleIconSVG: FC<ContactsPeopleIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="30"
            height="26"
            viewBox="0 0 30 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M23.0003 25C23.0003 22.171 21.8765 19.4579 19.8761 17.4575C17.8757 15.4571 15.1626 14.3333 12.3337 14.3333M12.3337 14.3333C9.50468 14.3333 6.79157 15.4571 4.79119 17.4575C2.7908 19.4579 1.66699 22.171 1.66699 25M12.3337 14.3333C16.0156 14.3333 19.0003 11.3486 19.0003 7.66667C19.0003 3.98477 16.0156 1 12.3337 1C8.65176 1 5.66699 3.98477 5.66699 7.66667C5.66699 11.3486 8.65176 14.3333 12.3337 14.3333ZM28.3337 23.6667C28.3337 19.1733 25.667 15 23.0003 13C23.8769 12.3424 24.5778 11.4788 25.0411 10.4857C25.5043 9.4926 25.7157 8.40062 25.6563 7.3064C25.597 6.21218 25.2689 5.14945 24.701 4.21227C24.133 3.27508 23.3428 2.49235 22.4003 1.93333"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ContactsPeopleIconSVG;
